import React from "react";

// Stylized "WC" serif monogram inspired by the Workin Chix brand mark.
// Pure SVG so it scales cleanly and ports to Wix without external dependencies.
export const Monogram = ({ size = 36, color = "currentColor", className = "" }) => (
  <svg
    viewBox="0 0 120 80"
    width={size}
    height={(size * 80) / 120}
    className={className}
    role="img"
    aria-label="Workin Chix Events monogram"
    data-testid="brand-monogram"
  >
    <text
      x="0"
      y="62"
      fontFamily="'Cormorant Garamond', 'Playfair Display', Georgia, serif"
      fontSize="78"
      fontWeight="600"
      fontStyle="italic"
      letterSpacing="-4"
      fill={color}
    >
      W
    </text>
    <text
      x="62"
      y="62"
      fontFamily="'Cormorant Garamond', 'Playfair Display', Georgia, serif"
      fontSize="78"
      fontWeight="600"
      fontStyle="italic"
      letterSpacing="-4"
      fill={color}
    >
      c
    </text>
  </svg>
);

export const Wordmark = ({ color = "currentColor", className = "" }) => (
  <div
    className={`flex flex-col items-center ${className}`}
    data-testid="brand-wordmark"
  >
    <Monogram size={42} color={color} />
    <div
      className="font-display"
      style={{
        color,
        fontSize: "1.5rem",
        letterSpacing: "0.06em",
        lineHeight: 1,
        marginTop: "0.25rem",
      }}
    >
      WORKIN CHIX
    </div>
    <div
      className="font-body tracking-overline"
      style={{ color, fontSize: "0.6rem", marginTop: "0.25rem" }}
    >
      Events
    </div>
  </div>
);
